import { User } from "../Model/User";
export class UsersService {
    constructor(httpService, queryParamsFactory) {
        this.httpService = httpService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async getMe() {
        const response = await this.httpService.get('user/me');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el usuario.');
        }
        return this.createUser(await response.json());
    }
    async getUser(userId) {
        const response = await this.httpService.get(`user/${userId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el usuario.');
        }
        return this.createUser(await response.json());
    }
    async queryUsers(query) {
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.httpService.get('users', params);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el usuario.');
        }
        const content = await response.json();
        return content.map(state => this.createUser(state));
    }
    async saveUser(user, password) {
        const response = await this.httpService.post('user', { user, password });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar el usuario.');
        }
    }
    async deleteUser(userId) {
        const response = await this.httpService.delete(`user/${userId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar el usuario.');
        }
    }
    createUser(state) {
        return new User(state.id, state.accountId, state.creationDate, state.lastLoginDate, state.lastActivityDate, state.enabled, state.typeId, state.name, state.email);
    }
}
